import { render, staticRenderFns } from "./EventPay.vue?vue&type=template&id=45b822d7&scoped=true"
import script from "./EventPay.vue?vue&type=script&lang=js"
export * from "./EventPay.vue?vue&type=script&lang=js"
import style0 from "./EventPay.vue?vue&type=style&index=0&id=45b822d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b822d7",
  null
  
)

export default component.exports